export default class LivestreamingDetail {

  constructor(options) {
    this.element = options.element;
    this.livestreamingDetail = document.querySelector('.livestreaming-expanded-detail');
    this.hasLoaded = false;
  }

  init() {
    if(!this.hasLoaded) {
      this.autoExpand();
    }
    this.bindClick();
  }

  autoExpand(){
    if(this.element.dataset.streamType == 'EventStream') {
      this.expand();
    }
    this.hasLoaded = true;
  }

  bindClick(){
    this.element.addEventListener('click', () => {
      if (this.isExpanded()) {
        this.collapse();
      } else {
        this.expand();
      }
    });
  }

  isExpanded(){
    return this.element.classList.contains('i-expanded');
  }

  expand(){
    this.element.classList.add('i-expanded');
    this.livestreamingDetail.classList.remove('hide');
  }

  collapse(){
    this.element.classList.remove('i-expanded');
    this.livestreamingDetail.classList.add('hide');
  }
}
